<template>
    <zen-message-modal :isOpen="isOpen" title="Archive Stale Flags?">
        Are you sure you want to archive {{ count }}
        {{ count === 1 ? 'flag' : 'flags' }}? Once archived, a flag is
        immediately unavailable and will not be returned to your applications
        from the API.
        <template v-slot:buttons>
            <zen-button
                variant="primary-danger"
                :processing="processing"
                data-testid="stale-flags-confirm-archive"
                @click="$emit('confirm')"
            >
                Archive
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'ArchiveStaleFlagsModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        count: {
            type: Number,
            default: 0,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
